export const updatePairedPhenotypesCountMixin = {
  methods: {
    onDataTableInput() {
      this.updatePairedPhenotypesCount();
    },
    updatePairedPhenotypesCount() {
      const next = this.$refs.DataTable.visibleItems.filter((i) => i.pairedPhenotypesCount === null);

      if (next.length === 0) {
        return;
      }

      const processingLabel = this.productBuildingInProgress
        ? this.$t('DataTable.Processing.Off')
        : this.$t('DataTable.Processing.On');

      next.forEach((item) => {
        item.pairedPhenotypesCount = processingLabel;
      });

      if (this.productBuildingInProgress) {
        return;
      }

      const productIds = next.map((item) => item.id).join(',');

      this.axios.get(`admin/products/pairedPhenotypesCounts?ProductIds=${productIds}`)
        .then((response) => {
          if (response.status === 200) {
            response.data.result.forEach(({ productId, count, isInvalid }) => {
              const item = next.find((visibleItem) => visibleItem.id === productId);

              if (item) {
                item.pairedPhenotypesCount = count;
                item.isInvalid = isInvalid;
              }
            });
          }
        });
    }
  }
};
